import { isDisplayable, isTruthyOrZero } from "util/misc";
import _ from "lodash";
import {
  getPassingCompletionPercentage,
  getPassingAverage,
  getRushingAverage,
  getReceivingAverage,
  getPuntingAverage
} from "../statsHelpers";
import { getOppositeSide } from "games/utils";

/*
 * These are stats that are not added up on individual plays.
 * They are averages and percentages based on the total values of other stats.
 * @param {object} stats
 * @returns {object}
 * @example
 *    getStatsFromTotals({passingAttempts: 2, passingYards: 10})
 */
const getStatsFromTotals = (stats) => {
  if (!stats) return {};

  const passingCompletionPercentage = getPassingCompletionPercentage(stats);
  const passingAverage = getPassingAverage(stats);
  const rushingAverage = getRushingAverage(stats);
  const receivingAverage = getReceivingAverage(stats);
  const puntingAverage = getPuntingAverage(stats);

  return {
    ...(isTruthyOrZero(passingCompletionPercentage) && {
      passingCompletionPercentage
    }),
    ...(isTruthyOrZero(passingAverage) && { passingAverage }),
    ...(isTruthyOrZero(rushingAverage) && { rushingAverage }),
    ...(isTruthyOrZero(receivingAverage) && { receivingAverage }),
    ...(isTruthyOrZero(puntingAverage) && { puntingAverage })
  };
};

/*
 * @param {object} stats
 * @returns {number}
 */
const getTotalYards = (stats) => {
  const passingYards = _.get(stats, "passingYards");
  const rushingYards = _.get(stats, "rushingYards");
  if (isDisplayable(passingYards) && isDisplayable(rushingYards)) {
    return passingYards + rushingYards;
  }
};

/*
 * @param {object} previousPlay
 * @param {"home"|"away"} side
 * @param {object} sideTeamStats
 * @param {object} oppositeSideTeamStats
 * @returns {object}
 */
const getTeamStatsFromTotals = ({
  previousPlay,
  side,
  sideTeamStats,
  oppositeSideTeamStats
}) => {
  const oppositeSide = getOppositeSide(side);
  const sideTotalPoints = _.get(previousPlay, `${side}TotalPoints`);
  const oppositeSideTotalPoints = _.get(
    previousPlay,
    `${oppositeSide}TotalPoints`
  );
  const sideTotalYards = getTotalYards(sideTeamStats) || 0;
  const oppositeSideTotalYards = getTotalYards(oppositeSideTeamStats) || 0;

  return {
    totalPoints: sideTotalPoints,
    pointsAllowed: oppositeSideTotalPoints,
    totalYards: sideTotalYards,
    yardsAllowed: oppositeSideTotalYards
  };
};

export { getStatsFromTotals, getTeamStatsFromTotals, getTotalYards };
